import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { useTheme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
const useStyles = makeStyles((theme) => ({
    heading: {
        flexBasis: '60%',
        flexShrink: 0,
        fontSize: theme.typography.body1.fontSize
    },
    secondaryHeading: {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.body1.fontSize
    },
    textField: {
        margin: theme.spacing(0)
    },
    toolBar: {
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center'
        },
        justifyContent: 'flex-end'
    }
}));
export const FormPanel = (props) => {
    const { heading, secondaryHeading, name, children, initialExpanded } = props;
    const classes = useStyles(useTheme());
    const [expanded, setExpanded] = useState(initialExpanded);
    const onCollapsePanelChange = (event, isExpanded) => setExpanded(isExpanded);
    return (React.createElement(ExpansionPanel, { onChange: onCollapsePanelChange, expanded: expanded },
        React.createElement(ExpansionPanelSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), "aria-controls": name, id: name },
            React.createElement(Typography, { className: classes.heading }, heading),
            expanded ? null : (React.createElement(Typography, { className: classes.secondaryHeading }, secondaryHeading))),
        React.Children.map(children, (child, index) => child ? React.createElement(ExpansionPanelDetails, { key: index }, child) : null)));
};
//# sourceMappingURL=FormPanel.js.map